// const myHeaders = new Headers();
// myHeaders.append('Content-Type', 'application/json');
const graphql = JSON.stringify({
  query: `query {
        eventsEn: events(lang: "en") {
        id
        title
        fallbackImage
        website
        startDate
        endDate
        tags {
            name
      }
    }
      eventsAr: events(lang: "ar") {
          id
          title
          fallbackImage
          website
          startDate
          endDate
          tags {
              name
          }
      }
  }`,
  variables: {},
});
var requestOptions = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: graphql,
  redirect: 'follow',
};

//const endpoint = 'https://apiqa.testvisitdubai.com/graphql/event';

export default () =>
  fetch('https://api.visitdubai.com/graphql/event', requestOptions)
    .then((response) => response.text())
    .then((result) => result)
    .catch((error) => console.log('error', error));
